import { Modal } from 'antd';
import styles from './index.module.sass';
import { useState } from 'react';
import managerSvg from '@@/seller-account/images/manager.svg';
import { ButtonMain } from '@/modules/common/components/button';

export const Notifier = ({
  onClick,
  buttonLabel,
  bgColor,
  textColor,
  heading,
  text,
  maxWidth,
  buttonDisabled,
}: IArgs) => {
  return (
    <>
      <div
        className={styles.root}
        style={{ backgroundColor: bgColor, maxWidth: maxWidth || 'none' }}
      >
        <span className={styles.heading} style={{ color: textColor }}>
          {heading}
        </span>
        <span className={styles.label} style={{ color: textColor }}>
          {text}
        </span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onClick && onClick();
          }}
          style={{
            color: bgColor,
            backgroundColor: textColor,
            userSelect: 'none',
            opacity: buttonDisabled ? '.75' : '1',
            pointerEvents: buttonDisabled ? 'none' : 'auto',
          }}
        >
          {buttonLabel}
        </a>
      </div>
    </>
  );
};

interface IArgs {
  onClick: () => void;
  buttonLabel: string;
  bgColor: string;
  textColor: string;
  heading: string;
  text: string;
  maxWidth?: number;
  buttonDisabled?: boolean;
}
